import PropTypes from 'prop-types'
import React from 'react'
import Trans from 'next-translate/Trans'
import config from 'SRC/config/config.json'

export const ProAvailable = ({ packages }) => {
  const text = config.registrationForm.package.proavailable

  return (
    <tr>
      <Trans
          i18nKey='common:packages_proavailable_text'
          components={{
            td: <td />,
            strong: <strong />
          }}
          defaultTrans='<td>Mogućnost <strong>PRO</strong> oznake</td>'
        />
      {packages.map(item => <td key={item.id}>{<i className={`ico-${item.proAvailable ? `ima` : `nema`} ico`} />}</td>)}
    </tr>
  )
}
ProAvailable.propTypes = {
  packages: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    proAvailable: PropTypes.bool
  })).isRequired
}

ProAvailable.defaultProps = {
  packages: []
}
